import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import ForecastTermRepository from '@/shared/http/repositories/business/forecastterm.js'
import SingModal from '../SingModal/SingModal.vue'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import LogAdvance from '@/views/private/travelreimbursement/components/FormDetailsAdvance/component/logAdvance'

export default {
  name: 'FormDetailsAdvance',
  mixins: [ActionsForm],
  props: {
    dataDetails: {
      type: Object,
      default: {}
    },
    refreshLog: {
      type: Boolean,
      default: false
    }
  },
  components: {HeadDetailsGama, SingModal, LogAdvance},
  filters: {
    formatDate (value) {
      let date = new Date(value)
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    }
  },
  data () {
    return {
      dataTermo: [],
      carregaSituacao: false,
      modalIdentifica: null,
      headTable: ['Qtd.', 'Despesa', 'Valor Unitário', 'Valor Total'],
      dataSpent: [],
      headTerm: ['Lote', 'Data Solicitação', 'Solicitante', 'Funcionário', 'Obra', 'Responsável', 'Valor', 'Viagem motivo', 'Viagem início', 'Viagem Fim', 'Cidade Origem', 'Cidade Fim', 'Status', 'Data Aprovação', 'Usuário aprovação', 'Situação Motivo', ''],
      totalTable: 0.0,
      hasFile: false,
      dataDespesaHistory: [],
      nameFile: '',
      file: [],
      dataSituacao: [],
      logAdvance: [],
      logallfilter: [],
      serachiput: '',
      meses: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
    }
  },
  mounted () {
    this.getAllHistoric()
    this.GetEnumSituacao()
    this.totalDespesa()
    this.getTermoId()

    this.GetLogById()
  },
  watch: {
    serachiput (newvalue) {
      this.logallfilter = this.logAdvance.filter((Element) => Element.titulo.toUpperCase().includes(newvalue.toUpperCase()))
    }
  },
  methods: {
    getTermoId () {
      AcceptanceTermRepository.TermoByid(this.dataDetails.id)
        .then(Response => {
          this.dataTermo = Response.data[0]
        })
        .catch(Error => console.log(Error))
    },
    onLoad () {
      ForecastTermRepository.GetAllByTermo(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.dataDetails.id)
        .then(Response => {
          this.dataSpent = Response.data.data
          // let total = 0
          // let totalObj = this.dataSpent.map((Element) => Element.valorUnitario * Element.quantidade)
          // totalObj.forEach((Element) => {
          //   total = total + Element
          // })
          // this.totalTable = total
          this.$refs.tableGrid.LoadAllByData(Response)
        })
        .catch(Error => console.log(Error))
    },
    totalDespesa () {
      ForecastTermRepository.GetAllByTermoTotal(this.dataDetails.id)
        .then(Response => {
          this.totalDespesa = Response.data.data
          let total = 0
          let totalObj = this.totalDespesa.map((Element) => Element.valorUnitario * Element.quantidade)
          totalObj.forEach((Element) => {
            total = total + Element
          })
          this.totalTable = total
        })
        .catch(Error => console.log(Error))
    },
    GetEnumSituacao () {
      AcceptanceTermRepository.GetEnumSituacao()
        .then(Response => {
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    addImg () {
      document.getElementById('input-hidden').click()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    getAllHistoric () {
      loading.push()
      AcceptanceTermRepository.GetAllHistoric(this.dataDetails.favorecidoID)
        .then(Response => {
          this.dataDespesaHistory = Response.data.data
          this.$refs.tableGridhistory.LoadAllByData(Response)
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    closeModalCan () {
      this.file = []
      document.getElementById('input-hidden').value = ''
      this.hasFile = false
      this.$refs['add-sign'].hide()
    },
    removeFile () {
      document.getElementById('input-hidden').value = ''
      this.hasFile = false
    },
    setFormaCityState (obj) {
      let result = null
      if (obj && obj.estado) {
        result = obj.nome + ' ' + obj.estado.sigla
      } else {
        result = obj.nome
      }
      return result
    },
    getStatus (situacao) {
      if (this.dataSituacao.length > 0) {
        let status = this.dataSituacao.find((Element) => parseInt(Element.value) === situacao)
        if (status !== undefined) {
          return status.text
        } else {
          return 'N/D'
        }
      }
      return 'N/D'
    },
    dowloadPdf () {
      loading.push()
      AcceptanceTermRepository.GetSignature(this.dataDetails.id)
        .then(Response => {
          let pdfWindow = window.open('Despesa-Diversos.pdf')
          let pdf = encodeURI(Response.data)
          pdfWindow.document.write(`
            <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
          `)
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    dowloadRecibo () {
      loading.push()
      AcceptanceTermRepository.GetAssinaturaVendaBaixada(this.dataDetails.id)
        .then(Response => {
          let pdfWindow = window.open('Despesa-Diversos.pdf')
          let pdf = encodeURI(Response.data)
          pdfWindow.document.write(`
            <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
          `)
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    setSing (value) {
      this.modalIdentifica = value
      this.$refs['add-sign'].show()
    },
    sendSign () {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('File', this.file)
      loading.push()
      AcceptanceTermRepository.sendSign(this.dataDetails.id, this.modalIdentifica, data, conf)
        .then((Response) => {
          this.getTermoId()
          this.closeModalCan()
          this.GetLogById()
          this.file = []
          document.getElementById('input-hidden').value = ''
          this.hasFile = false
          this.dataDetails.situacao = Response.data.situacao
          loading.pop()
          this.carregaSituacao = !this.carregaSituacao
          this.$emit('carregaSituacao', this.carregaSituacao)
          toast.success('Termo alterado com sucesso!!')
          this.sendsign = false
        })
        .catch(error => {
          toast.error('Não foi possivel adicionar a Assinatura')
          loading.pop()
          console.error(error)
        })
    },
    setValueInput (e) {
      if (e.target.files.length > 0) {
        this.file = e.target.files[0]
        this.hasFile = true
        this.nameFile = e.target.files[0].name
      } else {
        this.hasFile = false
        this.file = []
      }
    },
    print () {
      loading.push()
      AcceptanceTermRepository.printByTermo(this.dataDetails.id, this.modalIdentifica)
        .then(Response => {
          this.getTermoId()
          let pdf = Response.data.data
          let linkSource = `data:application/pdf;base64,${pdf}`
          let downloadLink = document.createElement('a')
          let fileName = 'Assinatura.pdf'
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetLogById () {
      loading.push()
      AcceptanceTermRepository.GetLogById(this.dataDetails.id)
        .then(Response => {
          this.logAdvance = Response.data

          loading.pop()
        })
    },
    mostrarNomeMes (event) {
      const mesInt = parseInt(event)
      if (mesInt >= 1 && mesInt <= 12) {
        return this.meses[mesInt - 1]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/FormDetailsAdvance/FormDetailsAdvance.js